export default __webpack_public_path__ + "static/media/pln-flag.b04013b1.svg";